import type { API } from 'chessboard/api/config/types';

/**
 * Create the getTurn method.
 */
export function createGetHistorySANs(context: API.Context) {
  /**
   * Get an array of SAN moves for the current history.
   */
  return function getHistorySANs() {
    const { game } = context;

    return game.history(false);
  };
}
